import React from "react";
import "../css/mobileapp.css";
import logo1 from "../assets/logo.png";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

export default function BarChartPage() {
  const data = [
    { name: "T", value: 60 },
    { name: "V", value: 90 },
    { name: "K", value: 120 },
  ];

  const colors = ["url(#grad1)", "url(#grad2)", "url(#grad1)"];

  return (
    <div className="mobile-container">

      {/* HEADER */}
      <div className="mobile-header">
        <img src={logo1} alt="TVK Logo" className="mobile-logo" />
      </div>

      {/* TITLE */}
      <h2 className="contact-title">📊 அறிக்கை (Report)</h2>

      {/* PREMIUM CARD */}
      <div className="chart-card">

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} barCategoryGap={30}>

            {/* 🔥 Gradients */}
            <defs>
              <linearGradient id="grad1" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#8B0000" stopOpacity={1}/>
                <stop offset="100%" stopColor="#ff4d4d" stopOpacity={1}/>
              </linearGradient>

              <linearGradient id="grad2" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#FFD700" stopOpacity={1}/>
                <stop offset="100%" stopColor="#FFA500" stopOpacity={1}/>
              </linearGradient>
            </defs>

            {/* AXIS */}
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />

            {/* TOOLTIP */}
            <Tooltip
              contentStyle={{
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
              cursor={{ fill: "rgba(0,0,0,0.05)" }}
            />

            {/* BARS */}
            <Bar dataKey="value" radius={[10, 10, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={index} fill={colors[index]} />
              ))}
            </Bar>

          </BarChart>
        </ResponsiveContainer>

      </div>

    </div>
  );
}